import React from 'react';
import { useSearchParams } from 'react-router-dom';
import './mainMenu.css';
import GameCard from './GameCard';
import { useAnimations } from '../shared/animations/useAnimations';
import { getVisibleGames, getGameActions, getGameEmoji, getGameDescription } from './manifest';

export default function MainApp() {
  const { animationsEnabled, toggleAnimations } = useAnimations();
  const [searchParams] = useSearchParams();
  const games = getVisibleGames(searchParams);

  return (
    <main className="home">
      <header className="home__header">
        <h1 className="gradient-cosmic">Games To Poop With</h1>
        <p className="home__tagline">So... you're pooping eh?</p>
      </header>

      <section className="home__games" aria-label="Game selection">
        {games.map((game) => (
          <GameCard
            key={game.slug}
            title={game.title}
            description={getGameDescription(game)}
            emoji={getGameEmoji(game)}
            actions={getGameActions(game)}
          />
        ))}
      </section>

      <button
        className="animations-toggle"
        onClick={toggleAnimations}
        aria-label={animationsEnabled ? 'Disable animations' : 'Enable animations'}
        title={animationsEnabled ? 'Pause animations' : 'Resume animations'}
      >
        {animationsEnabled ? '⏸️' : '▶️'}
      </button>
    </main>
  );
}
